export default __webpack_public_path__ + "static/media/4.46561903.png";